module.exports = __webpack_public_path__ + "static/media/1-Hero.98f42d2c.png";